import React, { useCallback, useContext } from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import validations from 'validations';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import { Button } from 'ncoded-component-library';
import PasswordField from 'components/PasswordField';
import authProcess from 'api/authProcess';
import CurrentUserContext from 'providers/CurrentUser';
import './SignupChangePassword.styles.scss';

type SignupChangePasswordProps = Record<string, any>;

const SignupChangePassword: React.FC<SignupChangePasswordProps> = (props) => {
  const { t } = useTranslation();
  const { popError } = useContext(PopNotificationsContext);
  const { updateUser } = useContext(CurrentUserContext);

  const handleSubmit = useCallback(
    async ({
      newPassword,
    }: {
      newPassword: string;
      confirmPassword: string;
    }) => {
      try {
        const { data } = await authProcess.changeInitialPassword(newPassword);
        updateUser(data);
      } catch (error: any) {
        popError(t('auth-password-error'));
        console.error(error);
      }
    },
    [popError, t, updateUser],
  );

  return (
    <div className="auth-form-wrapper">
      <h2>{t('change-password-title')}</h2>
      <p>{t('change-password-paragraph')}</p>
      <Form
        onSubmit={handleSubmit}
        render={({ handleSubmit, submitting, valid }) => {
          return (
            <form onSubmit={handleSubmit} autoComplete="off">
              <PasswordField
                placeholder={t('new-password')}
                label={t('new-password')}
                name="newPassword"
              />

              <PasswordField
                name="confirmPassword"
                placeholder={t('confirm-password')}
                label={t('confirm-password')}
                validate={validations.isFieldEqualTo(
                  'newPassword',
                  t('confirm-password-validation-message'),
                )}
              />
              <Button type="submit" disabled={submitting || !valid}>
                {t('change')}
              </Button>
            </form>
          );
        }}
      />
    </div>
  );
};

export default SignupChangePassword;
